{
  "Home": "Home",
  "All learning": "All learning",
  "Profile": "Profile",
  "Network": "Network",
  "Notifications": "Notifications",
  "Admin": "Admin",
  "Manager": "Manager",
  "Logout": "Log out",
  "Ongoing learnings": "Ongoing",
  "My learning": "My learning",
  "Assigned": "Assigned",
  "Saved by me": "Saved",
  "Completed": "Completed",
  "Approval": "Approval",
  "Order history": "Application history",
  "Assign": "Assign",
  "Groups": "Groups",
  "Users": "Users",
  "Teams": "Teams",
  "Time tracking": "Import time",
  "Exit admin": "Exit admin",
  "Exit": "Exit Admin",
  "Content": "Content",
  "People": "People",
  "Journeys": "Journeys",
  "Approve": "Approve",
  "Analyze": "Analyze",
  "No notifications": "No notifications",
  "No ongoing learnings": "No ongoing learning items",
  "Give us feedback": "Give us feedback",
  "Go to previous campus": "Go to previous campus",
  "Analytics": "Analytics",
  "Close the menu": "Close menu",
  "Open the menu": "Open menu",
  "Clear notifications": "Clear notifications",
  "Campus Online Data": "Campus Online Data",
  "Explore": "Explore",
  "Search learning items": "Search learning items",
  "Site logo": "Site logo",
  "View all learning items": "View all learning items",
  "Top providers": "Top partners",
  "View all providers": "View all partners"
}
